import {createContext} from "react";

const WidgetContext = createContext();

export default WidgetContext;